mutation UpdatePlatformPages($ids: [ID!]!, $input: UpdatePlatformPagesInput!) {
  updatePlatformPages(ids: $ids, input: $input) {
    id
    publishAt
  }
}
